import React from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCoins, faFire, faPencil, faPerson} from "@fortawesome/free-solid-svg-icons";
import AccountMenu from "./AccountMenu";
import CharacterImage from "../../components/user/CharacterImage";

const AccountSidebar = ({name, phone_number, credit, streak, xp, character}) => {
    return (
        <>
            <div className='w-full mt-10 lg:mt-0 lg:w-1/5 order-2 lg:order-1 lg-w-1/3'>
                <div
                    className='w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100 p-10 flex justify-center items-center flex-col mb-5'>

                    <CharacterImage characterCode={character} />

                    <span className='text-lg block font-bold mt-5'>
                                    {name}
                                </span>

                    <span className='text-md block font-bold mt-3 text-gray-700'>
                                    {phone_number}
                                </span>
                </div>

                <div
                    className='w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100 flex items-center mb-5'>

                    <div
                        className='w-1/3 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                        <span>{credit}</span>
                        <FontAwesomeIcon icon={faCoins} size='md'/>
                    </div>

                    <div
                        className='w-1/3 border-l-2 flex justify-center items-center gap-x-3 border-gray-200 p-5'>
                        <span>{streak}</span>
                        <FontAwesomeIcon icon={faFire} size='md'/>
                    </div>

                    <div className='w-1/3 flex justify-center items-center gap-x-3'>
                        <span>{xp}</span>
                        <FontAwesomeIcon icon={faPerson} size='md'/>
                    </div>
                </div>

                <AccountMenu/>
            </div>
        </>
    )
}

export default AccountSidebar;